import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "biosyn_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const admin = axios.create({ baseURL: API });
admin.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const fileUrl = (urlOrPath) => {
  if (!urlOrPath) return "";
  if (urlOrPath.startsWith("http")) return urlOrPath;
  return `${BACKEND_URL}${urlOrPath.startsWith("/") ? "" : "/"}${urlOrPath}`;
};

export const login = (email, password) =>
  admin.post("/auth/login", { email, password }).then((r) => r.data);
export const fetchMe = () => admin.get("/auth/me").then((r) => r.data);

export const adminListProducts = () => admin.get("/admin/products").then((r) => r.data);
export const createProduct = (payload) => admin.post("/products", payload).then((r) => r.data);
export const updateProduct = (slug, payload) => admin.put(`/products/${slug}`, payload).then((r) => r.data);
export const deleteProduct = (slug) => admin.delete(`/products/${slug}`).then((r) => r.data);
export const reorderProducts = (items) => admin.post("/admin/products/reorder", items).then((r) => r.data);

export const uploadFile = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return admin.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};

export const listEnquiries = (params = {}) => admin.get("/enquiries", { params }).then((r) => r.data);
export const enquiryStats = () => admin.get("/enquiries/stats").then((r) => r.data);
export const updateEnquiry = (id, payload) => admin.put(`/enquiries/${id}`, payload).then((r) => r.data);

export default admin;
